module.exports = __webpack_public_path__ + "img/racecourse-durbanville-turf-1200.acede3f3.svg";